<template>
    <div class="tabs__content-helper">
        Imgur
    </div>
</template>
